import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const creditOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "账号",
            prop: "account",
            search: true,
            editVisdiplay: false,
            type: 'input'
        },
        {
            label: "店铺名称",
            prop: "shopName",
            type: "input",
            search: true,
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "法人名称",
            prop: "name",
            type: "input",
            search: true,
            editVisdiplay: false,
            width: "110"
        },
        // {
        //     label: "法人名称",
        //     prop: "name",
        //     width: "110",
        //     type: 'input',
        //     search: true,
        //     solt: true,
        //     formsolt: true,
        // },
        {
            label: "店铺地址",
            prop: "shopAddress",
            type: "input",
            editVisdiplay: false,
            search: true
        },
        {
            label: "上次采购时间",
            prop: "lastPurchaseTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "结算方式",
            prop: "clearingType",
            // solt: true,
            search: true,
            type: 'select',
            dicData: DIC.FINANCIAL_STATUS,
            addVisdiplay: false,
            //hide: true
        },
        {
            label: "剩余未结算",
            prop: "waitPayCount",
            // solt: true,
            width: "110",
            editVisdiplay: false,
            type: 'input',
        },
        {
            label: "未结算金额",
            prop: "waitPayPrice",
            // solt: true,
            type: 'input',
            editVisdiplay: false,
            width: "110"
        },
        {
            label: "支付时间区间",
            prop: "payTimeInterval",
            type: "datetimerange",
            sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            // search: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "采购时间",
            prop: "startDate_endDate",
            type: "datetimerange",
            valueFormat: "timestamp",
            span: 24,
            clearable: true,
            hide: true,
            addVisdiplay: false,
            editVisdiplay: false,
            formatter: function (row, value, label, column) {
                return formatterTime(row.startTime) + '至' + formatterTime(row.endTime)
            }
        }
    ]
};